"use client"

import { Chip } from "@mui/material"
import { motion } from "framer-motion"

const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case "active":
      return "success"
    case "trial":
      return "info"
    case "canceled":
      return "error"
    case "pending_cancellation":
      return "warning"
    case "paused":
      return "warning"
    case "past_due":
      return "error"
    case "expired":
      return "error"
    case "paid":
      return "success"
    case "open":
      return "info"
    case "draft":
      return "default"
    case "uncollectible":
      return "error"
    case "void":
      return "error"
    default:
      return "default"
  }
}

const getStatusLabel = (status) => {
  // Replace underscores with spaces and capitalize each word
  return status
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

const StatusBadge = ({ status, cancelType, size = "small" }) => {
  // If the subscription is active but has a cancelType of "end_of_cycle", display as "Pending Cancellation"
  let displayStatus = status
  if (status === "active" && cancelType === "end_of_cycle") {
    displayStatus = "pending_cancellation"
  }

  return (
    <Chip
      component={motion.div}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.05 }}
      label={getStatusLabel(displayStatus)}
      color={getStatusColor(displayStatus)}
      size={size}
      sx={{
        textTransform: "capitalize",
        fontWeight: 600,
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.08)",
      }}
    />
  )
}

export default StatusBadge

